import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, ContainerCol, SubTituloForm, ContenedorBoton } from '../componentes_generales/componentes_formulario/contenedores';
import { LabelForm, LabelTotales, LabelValorTotales } from '../componentes_generales/componentes_formulario/labels';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import global_axios from '../../funciones_globales/interaccionapi';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { obtenerSecuencial } from '../../funciones_globales/parametros';
import { Responsive, WidthProvider } from 'react-grid-layout';
import '../componentes_generales/gridLayout/estiloGridLayout.css'
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import { cargarCatalogosGenericoAsync, cargarCatalogos } from '../../funciones_globales/catalogos';
import styled from 'styled-components';
import { cargar_Cliente, inicializarCliente } from '../../actions/clientes/act_cli01';
import { validarCampoString, validarJSON, validarFechaMomentEnFormatoString, validarFechaTransaccionSeleccionada, validarPermisoAcceso, esNumero } from '../../funciones_globales/utils';
import moment from 'moment';
import { TextArea } from '../componentes_generales/componentes_formulario/textArea/textarea';
import { formatearNumeroDecimal, formatearFechaMoment_a_String, formatearFecha } from '../../funciones_globales/format';
import { cargar_GestionesPorCliente, cargar_GestionesPlanificadas } from '../../actions/clientes/act_cli06';
const ResponsiveGridLayout = WidthProvider(Responsive);

const ContenedorFormSinColorFondo = styled(ContenedorForm)`
  background-color: transparent;
  border: none;
`;

const SubContenedorForm = styled.div`
  border: 1px solid #cfd8dc;
  margin-top: ${props => props.margen_arriba?props.margen_arriba:0}px;
`;

const LabelPropCliente = styled.h6`
  font-size: 10px;
  font-weight: 600;
  display: inline-block;
  margin: 0 auto;
  padding: 0 auto;
`;

const LabelValueCliente = styled.p`  
  font-size: 10px;
  display: inline-block;
  margin: 0 0 0 5px;
  padding: 0 auto;
`;

const ContainerModalDetDocs = styled.div`
  margin-top: 20px;
  height: 450px;
  width: 700px;
`;

const BotonLinkDetDocumentos = styled.a`
  font-size: 10px;
  cursor: pointer;
`;

const TituloModalDetDocumentos = styled.h5`
  color: darkred;
  font-weight: 600;
`;

class FormCli13 extends React.Component{

  constructor(props) {
    super(props);
    this.state = {
      operacion: 'G',
      cliente_sel: null,
      saldosCliente: null,

      ultSecuencial: '',
      tipoGestion_sel: null,
      fechaGestion: null,
      observacion: '',
      fechaProxGestion: null,
      tipoProxGestion_sel: null,
      tiposGestion: [],
      isVisibleModalDetDocs: false,
      detalleDocumentos: [],
      tituloModalDetDocumentos: '',
      saldoDocumentos: 0,

      columnsDefGridUltGestiones: [
        { header: 'No.',
          field: 'Nro',
          width: 30,
          type: 'num_entero'
        },
        { header: 'Cód. Gestión',
          field: 'CodGestion',
          width: 80,
          type: 'string'
        },
        { header: 'Fecha',
          field: 'Fecha',
          width: 80,
          type: 'string'
        },
        { header: 'Gestión',
          field: 'Gestion',
          width: 220,
          type: 'string'
        },
        { header: 'Observación',
          field: 'Observacion',
          width: 435,
          type: 'string'
        },
        { header: 'Usuario',
          field: 'Usuario',
          width: 90,
          type: 'string'
        },
        { header: 'D. Total',
          field: 'DeudaTotal',
          width: 85,
          type: 'num_decimal'
        },
        { header: 'V. Vencido',
          field: 'SaldoVencido',
          width: 85,
          type: 'num_decimal'
        },
        { header: 'V. Por Vencer',
          field: 'SaldoPorVencer',
          width: 85,
          type: 'num_decimal'
        }
      ],

      columnsDefGridPlanGestiones: [
        { header: 'No.',
          field: 'Nro',
          width: 35,
          type: 'num_entero'
        },
        { header: 'Plan Gestión',
          field: 'IdPlanGestion',
          width: 90,
          type: 'num_entero'
        },    
        { header: 'Fecha',
          field: 'Fecha',
          width: 95,
          type: 'string'
        },
        { header: 'Cliente',
          field: 'Cliente',
          width: 290,
          type: 'string'
        },
        { header: 'Gestión',
          field: 'Gestion',
          width: 205,
          type: 'string'
        },        
        { header: 'Usuario',
          field: 'Usuario',
          width: 95,
          type: 'string'
        },
        { header: "",
          field: "aceptar",
          width: 85,
          type: "link_aceptar"
        }
      ],
      
      columnsDefGridDetDocs: [        
        { header: 'No.',
          field: 'Nro',
          width: 35,
          type: 'num_entero'
        },
        { header: 'No. Doc.',
          field: 'NumDoc',
          width: 120,
          type: 'string'
        },
        { header: 'Tipo Doc.',
          field: 'TipoDoc',
          width: 63,
          type: 'string'
        },
        { header: 'Valor',
          field: 'Importe',
          width: 80,
          type: 'num_decimal'
        },
        { header: 'Saldo',
          field: 'Saldo',
          width: 80,
          type: 'num_decimal'
        },
        { header: 'Fecha',
          field: 'Fecha',
          width: 85,
          type: 'string'
        },
        { header: 'F. Vcto.',
          field: 'FechaVencimiento',
          width: 85,
          type: 'string'
        },
        { header: 'F. Inic. Pago',
          field: 'FechaInicioPago',
          width: 85,
          type: 'string'
        },
        { header: 'D. Plazo',
          field: 'DiasPlazo',
          width: 65,
          type: 'num_entero'
        },
      ]
    };

    this.gridUltGestionesOptions = {
      enableSorting: true      
    };

    this.gridPlanGestionesOptions = {
      enableSorting: true,
      context: {
        componentParent: this
      }
    };

    this.gridDetDocsOptions = {
      enableSorting: true      
    };
     
    this.limpiarNuevaGestion = this.limpiarNuevaGestion.bind(this);
    this.limpiarInfoCliente = this.limpiarInfoCliente.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.cargarCliente = this.cargarCliente.bind(this);
    this.guardarGestionCliente = this.guardarGestionCliente.bind(this);
    this.cargarGestionesPlanificadas = this.cargarGestionesPlanificadas.bind(this);
    this.cargarDetalleDocumentos = this.cargarDetalleDocumentos.bind(this);
  }

  onGridUltGestionesReady(params) {
    this.apiGridUltGestiones = params.api;
    this.columnApiUltGestiones = params.columnApi;
  }

  onGridPlanGestionesReady(params) {
    this.apiGridPlanGestiones = params.api;
    this.columnApiPlanGestiones = params.columnApi;
  }

  onGridDetDocsReady(params) {
    this.apiGridDetDocs = params.api;
    this.columnApiDetDocs = params.columnApi;
  }

  methodFromParent(id, itemPlanGestion) {
    try {
      let eliminar = window.confirm('¿Está seguro de confirmar el cumplimiento de la gestión seleccionada?');
      if (eliminar){
        let idPlanGestion = itemPlanGestion.IdPlanGestion;

        this.props.cambiar_VisualizacionLoading(true);

        global_axios({
          method: 'PUT',
          url: `/plangestionescliente/${idPlanGestion}`,
          data: {
            status: 'R'
          },
          headers: {'idregaudit': this.props.idRegAudit}
        })
        .then(() =>{
          this.props.cambiar_VisualizacionLoading(false);
          alert(`Se actualizó correctamente la realización de la gestión planificada: ${idPlanGestion}`);
          this.cargarGestionesPlanificadas();
        })
        .catch(error =>{
          this.props.cambiar_VisualizacionLoading(false);
          alert(error.response?error.response.data.msg:error.message);
        });
      }
    } catch (error) {
      alert(`Ocurrió un error al actualizar el estado de la gestión planificada. Error: ${error}`);
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }
  
  componentDidMount(){
    Promise.all([
      obtenerSecuencial('GestionCli'),
      cargarCatalogos('LLCOBRO')
    ])
    .then(([secGestionCli, tiposGestion])=>{
      this.setState({ultSecuencial: secGestionCli.codigo - 1, tiposGestion})
    })
    .catch(error=>{
      alert(`No se pudo cargar los parámetros requeridos . Error: ${error}`);
    });
    
    this.props.generar_LogAuditoriaIngresoForm('0113');
    this.props.inicializarCliente();
    let fechaProceso = moment(getFechaProcesoPorModulo('01'), 'DD/MM/YYYY');    
    this.setState({fechaGestion: fechaProceso, fechaDesde: fechaProceso, fechaHasta: fechaProceso},
      ()=>  this.cargarGestionesPlanificadas());
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0113');
  }

  getOptions_Clientes(input, callback){
    if (input.toString().length >= 3 ){
      let query = '?tipo=catalogo&cadena_busq=' + input;     
      cargarCatalogosGenericoAsync('/clientes', query, callback)
    }
  }

  cargarCliente(){
    if(!validarCampoString(this.state.cliente_sel, 7)){
      alert('No ha seleccionado el cliente que desea consultar.');
      return;
    }

    try {
      // Se cargan los datos generales del cliente.
      this.props.cargar_Cliente(this.state.cliente_sel)
      .then(()=>{
        this.props.cargar_GestionesPorCliente(this.state.cliente_sel);
      });

      // Se cargan los saldos del cliente.
      global_axios({
        method: 'GET',
        url: `/clientes?cliente=${this.state.cliente_sel}&dcartera=true`
      })
      .then(response=>{
        this.setState({saldosCliente: response!==null?response.data:null});
      })
      .catch(()=> {
        this.setState({saldosCliente: null});
      });
    } catch (error) {
      alert(`Ocurrió un error al cargar los datos del cliente. Error: ${error}`);
    }
  }

  cargarGestionesPlanificadas(){
    let fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde);
    if (!validarFechaMomentEnFormatoString(fechaDesde)){
      alert('La fecha Desde es inválida.');
      return;
    }
    
    let fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta);
    if (!validarFechaMomentEnFormatoString(fechaHasta)){
      alert('La fecha Hasta es inválida.');
      return;
    }

    if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){        
      alert(`La fecha Desde debe ser menor a: ${formatearFechaMoment_a_String(this.state.fechaHasta)}`);
      return;
    }

    this.props.cargar_GestionesPlanificadas(fechaDesde, fechaHasta);
  }  

  limpiarNuevaGestion(){
    let fechaProceso = moment(getFechaProcesoPorModulo('01'), 'DD/MM/YYYY');    

    this.setState({
      tipoGestion_sel: null,
      fechaGestion: fechaProceso,      
      observacion: '',
      fechaProxGestion: null,
      tipoProxGestion_sel: null
    });
  }

  limpiarInfoCliente(){
    this.setState({
      cliente_sel: null,
      saldosCliente: null,
      tituloModalDetDocumentos: '',
      saldoDocumentos: 0
    });

    this.props.inicializarCliente();
  }

  cargarDetalleDocumentos(tipoDocs){
    let fechaProceso = getFechaProcesoPorModulo('01');
    let idCliente = this.state.cliente_sel;

    if(!validarCampoString(idCliente, 7)){
      alert('No ha seleccionado un cliente.');
      return;
    }

    global_axios({
      method: 'GET', 
      url: `/clientes?tipoproceso=${tipoDocs}&cliente=${idCliente}&fechaProceso=${fechaProceso}`
    })
    .then((response)=>{
      try {
        let detalleDocumentos = [], saldoDocumentos = 0;
        
        response.data.forEach((doc, i)=>{
          detalleDocumentos.push({
            ...doc,
            Nro: (i+1),
            Fecha: formatearFecha(doc.Fecha),
            FechaVencimiento: formatearFecha(doc.FechaVencimiento),
            FechaInicioPago: formatearFecha(doc.FechaInicioPago)           
          });

          saldoDocumentos += parseFloat(doc.Saldo===null?0:doc.Saldo);
        });

        if(detalleDocumentos.length===0){
          this.setState({detalleDocumentos, saldoDocumentos});
          alert('El cliente no tiene documentos del tipo seleccionado.');
        }else{
          let tituloModalDetDocumentos;
          switch (tipoDocs) {
            case 'VENCIDO':
              tituloModalDetDocumentos = 'DETALLE DE DOCUMENTOS VENCIDOS';
              break;
            case 'PORVENCER':
              tituloModalDetDocumentos = 'DETALLE DE DOCUMENTOS POR VENCER';
              break;
            case 'CREDITO':
              tituloModalDetDocumentos = 'DETALLE DE NOTAS DE CRÉDITO';
              break;
            case 'CHEPOST':
              tituloModalDetDocumentos = 'DETALLE DE CHEQUES POSTFECHADOS';
              break;
            default:
              tituloModalDetDocumentos = '';
              break;
          }

          this.setState({detalleDocumentos, isVisibleModalDetDocs: true, tituloModalDetDocumentos, saldoDocumentos});
        }
      } catch (error) {
        alert(`Ocurrió un error al cargar los documentos del cliente. Error: ${error}`);
      }
    })
    .catch((error)=> {
      alert(error.response.data.msg?error.response.data.msg:error.message);
    });
  }

  guardarGestionCliente(){
    try{
      let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
      if (!validPermiso.esValido){
        alert(validPermiso.msg);
        return;
      }

      if(!validarJSON(this.props.clienteSel)){
        alert('No ha seleccionado un cliente.');
        return;
      }

      let fechaGestion = formatearFechaMoment_a_String(this.state.fechaGestion);      

      if (!validarFechaMomentEnFormatoString(fechaGestion)){
        alert('La fecha de la Gestión es inválida.');
        return;
      }

      let fechaProceso = getFechaProcesoPorModulo('01');
      if (this.props.permiteCambioFProceso==='S'){
        let validFProceso = validarFechaTransaccionSeleccionada(this.state.fechaGestion, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
        
        if(!validFProceso.esValida){
          alert(validFProceso.msg);
          return;
        }
      }
      
      let totalDeuda = 0, saldoVencido = 0, saldoPorVencer = 0, valorNotasCred = 0, valorChqPostf = 0;
      if(this.state.saldosCliente!==null){
        saldoVencido = parseFloat(!esNumero(this.state.saldosCliente.VencidoValor)?0:this.state.saldosCliente.VencidoValor).toFixed(2);
        saldoPorVencer = parseFloat(!esNumero(this.state.saldosCliente.PorVencerValor)?0:this.state.saldosCliente.PorVencerValor).toFixed(2);
        totalDeuda = parseFloat(saldoVencido) + parseFloat(saldoPorVencer);
        valorNotasCred = parseFloat(!esNumero(this.state.saldosCliente.Credito)?0:this.state.saldosCliente.Credito).toFixed(2);
        valorChqPostf = parseFloat(!esNumero(this.state.saldosCliente.ValorChequePosFechado)?0:this.state.saldosCliente.ValorChequePosFechado).toFixed(2);        
      }

      let fechaProxGestion = null, fechaProxGestion_tmp = formatearFechaMoment_a_String(this.state.fechaProxGestion);
      let tipoProxGestion = null;

      if (validarFechaMomentEnFormatoString(fechaProxGestion_tmp) && this.state.tipoProxGestion_sel!==null){
        if(this.state.fechaProxGestion.diff(this.state.fechaGestion, 'days')<=0){
          alert(`Error: La fecha de la Próxima Gestión debe ser mayor que: ${fechaGestion}`);
          return;
        }else{
          fechaProxGestion = formatearFechaMoment_a_String(this.state.fechaProxGestion);
          tipoProxGestion = this.state.tipoProxGestion_sel;
        }
      }else{
        if(this.state.tipoProxGestion_sel === null && validarFechaMomentEnFormatoString(fechaProxGestion_tmp)){
          alert('Error: Si desea añadir en agenda una Próxima Gestión para el cliente seleccionado debe especificar la Fecha y el Tipo de Gestión.');
          return;
        }

        if(this.state.tipoProxGestion_sel !== null && !validarFechaMomentEnFormatoString(fechaProxGestion_tmp)){
          alert('Error: Si desea añadir en agenda una Próxima Gestión para el cliente seleccionado debe especificar la Fecha y el Tipo de Gestión.');
          return;
        }
      }

      this.props.cambiar_VisualizacionLoading(true);      

      global_axios({
        method: 'POST',
        url: '/gestionescliente',
        data: {
          cliente: this.props.clienteSel.codigo===undefined?null:this.props.clienteSel.codigo,
          fechaGestion,
          tipoGestion: this.state.tipoGestion_sel,
          observacion: this.state.observacion,          
          oficialCred: this.props.clienteSel.oficial_credito===undefined?null:this.props.clienteSel.oficial_credito,
          usuario: getItemDatosSesion('usuario'),
          deudaTotal: totalDeuda,
          saldoVencido,
          saldoPorVencer,
          notasCredito: valorNotasCred,
          chqPostfechados: valorChqPostf,
          fechaSigGestion: fechaProxGestion,
          tipoSigGestion: tipoProxGestion
        }
      })
      .then(response =>{
        this.props.cambiar_VisualizacionLoading(false);
        let codGestionCli = response.data.codigoGestion;
        alert('Se generó correctamente la Gestión de Cliente: ' + codGestionCli);
        this.limpiarNuevaGestion();
      })
      .catch(error =>{
        this.props.cambiar_VisualizacionLoading(false);
        alert(error.response?error.response.data.msg:error.message);
      });
    }catch(error){
      this.props.cambiar_VisualizacionLoading(false);
      alert(error);
    }    
  }
  
  render(){
    let layoutlgGrid = [
      {i: 'g1', x: 0, y: 0, w: 9, h: 3, minW: 9, minH: 1, maxW: 9 }
    ];

    let layoutsGrid = {lg: layoutlgGrid};

    let clienteSeleccionado = validarJSON(this.props.clienteSel)?this.props.clienteSel:null;
    let saldosCliente = validarJSON(this.state.saldosCliente)?this.state.saldosCliente:null;    
    let gestionesCliente = [];
    if(clienteSeleccionado!==null && clienteSeleccionado.gestiones!==undefined){
      clienteSeleccionado.gestiones.forEach((gestion, i) => {
        gestionesCliente.push({
          ...gestion,
          Nro: (i+1),
          Gestion: `${gestion.tipoGest.Codigo} - ${gestion.tipoGest.Descripcion}`
        });
      });
    }

    let planGestionesCliente = [];
    if(this.props.gestionesClientePlanif!==undefined){
      this.props.gestionesClientePlanif.forEach((gestion, i) => {
        planGestionesCliente.push({
          ...gestion,
          Nro: (i+1),
          Cliente: `${gestion.cli.Codigo} - ${gestion.cli.Nombre}`,
          Gestion: `${gestion.tipoGest.Codigo} - ${gestion.tipoGest.Descripcion}`
        });
      });
    }

    return(
      <ContenedorFormSinColorFondo porc_ancho={90}>
          <SubContenedorForm>
            <HeaderForm>
              <SubTituloForm>Gestiones Planificadas</SubTituloForm>
            </HeaderForm>
            <CuerpoForm>
              <Row>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Fecha Desde:</LabelForm>
                  <PickerFecha fechaSeleccionada={this.state.fechaDesde} 
                    func_onChange={(fecha)=>{this.setState({fechaDesde: fecha});}}/> 
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Fecha Hasta:</LabelForm>
                  <PickerFecha fechaSeleccionada={this.state.fechaHasta} 
                    func_onChange={(fecha)=>{this.setState({fechaHasta: fecha});}}/>
                </ContainerCol>
                <ContainerCol className='col-sm-1'>
                  <ContenedorBoton margen_arriba={20}>
                    <Tooltip placement='right' overlay='Buscar Gestiones Planificadas'>
                      <button type='button' className='btn btn-success btn-sm' onClick={this.cargarGestionesPlanificadas}>
                        <i className='fa fa-search'></i></button>
                    </Tooltip>
                  </ContenedorBoton>
                </ContainerCol>
              </Row>
              <Row>
                <ResponsiveGridLayout className='layout' layouts={layoutsGrid} rowHeight={30}
                  cols={{lg: 12, md: 10, sm: 6, xs: 4, xxs: 2}}
                  breakpoints={{lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0}}          
                  isDraggable={false}>
                  <div key='g1'>
                    <AgGridRender altura='100%' data={planGestionesCliente} columnas={this.state.columnsDefGridPlanGestiones}
                      gridOptions={this.gridPlanGestionesOptions} onGridReady={this.onGridPlanGestionesReady}/>
                  </div>
                </ResponsiveGridLayout>              
              </Row>
            </CuerpoForm>
          </SubContenedorForm>
            
          <SubContenedorForm margen_arriba={30}>
            <HeaderForm>
              <SubTituloForm>Datos de Cliente</SubTituloForm>
            </HeaderForm>
            <CuerpoForm>
              <Row>
                <ContainerCol className='col-sm-4'>
                  <LabelPropCliente>Cliente:</LabelPropCliente>
                    <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} 
                      func_onChange={(value)=>{if(Array.isArray(value)){value=null} this.setState({cliente_sel: value===null?null:value.value})}}
                      func_OnFocus={this.limpiarInfoCliente}/>
                </ContainerCol>
                <ContainerCol className='col-sm-1'>
                  <ContenedorBoton margen_arriba={20}>
                    <Tooltip placement='right' overlay='Buscar datos del cliente'>
                      <button type='button' className='btn btn-success btn-sm' onClick={this.cargarCliente}>
                        <i className='fa fa-search'></i></button>
                    </Tooltip>
                  </ContenedorBoton>
                </ContainerCol>
              </Row>
              <Row margen_arriba={10}>
                <ContainerCol className='col-sm-4'>
                  <LabelPropCliente>Cliente:</LabelPropCliente>
                  <LabelValueCliente>{clienteSeleccionado===null?'':`${clienteSeleccionado.nombre} (${clienteSeleccionado.codigo})`}</LabelValueCliente>
                </ContainerCol>
                <ContainerCol className='col-sm-4'>
                  <LabelPropCliente>No. Identificación:</LabelPropCliente>
                  <LabelValueCliente>{clienteSeleccionado===null?'':clienteSeleccionado.cedula_ruc}</LabelValueCliente>
                </ContainerCol>
                <ContainerCol className='col-sm-4'>
                  <LabelPropCliente>Email:</LabelPropCliente>
                  <LabelValueCliente>{clienteSeleccionado===null?'':clienteSeleccionado.email_representante}</LabelValueCliente>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-4'>
                  <LabelPropCliente>Teléfono:</LabelPropCliente>
                  <LabelValueCliente>{clienteSeleccionado===null?'':clienteSeleccionado.telefono}</LabelValueCliente>
                </ContainerCol>
                <ContainerCol className='col-sm-4'>
                  <LabelPropCliente>Celular.:</LabelPropCliente>
                  <LabelValueCliente>
                    {clienteSeleccionado===null?'':clienteSeleccionado.celular_contacto_cia}
                  </LabelValueCliente>
                </ContainerCol>
                <ContainerCol className='col-sm-4'>
                  <LabelPropCliente>Contacto en la Emp.:</LabelPropCliente>
                  <LabelValueCliente>
                    {clienteSeleccionado===null?'':clienteSeleccionado.contacto_cia}
                  </LabelValueCliente>
                </ContainerCol>
                <ContainerCol className='col-sm-12'>
                  <LabelPropCliente>Dirección Principal:</LabelPropCliente>
                  <LabelValueCliente>
                    {clienteSeleccionado===null?'':`${clienteSeleccionado.direccion_principal} | ${(clienteSeleccionado.ciudad===null || clienteSeleccionado.ciudad===undefined)?'':clienteSeleccionado.ciudad.label}`}
                  </LabelValueCliente>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-4'>
                  <LabelPropCliente>Cupo:</LabelPropCliente>
                  <LabelValueCliente>
                    {clienteSeleccionado===null?'':(clienteSeleccionado.cupo===null?'':formatearNumeroDecimal(clienteSeleccionado.cupo))}
                  </LabelValueCliente>
                </ContainerCol>
                <ContainerCol className='col-sm-4'>
                  <LabelPropCliente>Deuda Total:</LabelPropCliente>
                  <LabelValueCliente>{saldosCliente===null?'':formatearNumeroDecimal(
                    parseFloat((saldosCliente.VencidoValor===null?0:saldosCliente.VencidoValor)+
                    (saldosCliente.PorVencerValor===null?0:saldosCliente.PorVencerValor)).toFixed(2))}</LabelValueCliente>
                </ContainerCol>
                <ContainerCol className='col-sm-3'>
                  <LabelPropCliente>Valor Vencido:</LabelPropCliente>
                  <LabelValueCliente>
                    {saldosCliente===null?'':(saldosCliente.VencidoValor===null?'':formatearNumeroDecimal(saldosCliente.VencidoValor))}
                  </LabelValueCliente>
                </ContainerCol>
                <ContainerCol className='col-sm-1'>
                  <BotonLinkDetDocumentos onClick={()=>{this.cargarDetalleDocumentos('VENCIDO')}}>Ver Detalle</BotonLinkDetDocumentos>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-3'>
                  <LabelPropCliente>Valor Por Vencer:</LabelPropCliente>
                  <LabelValueCliente>
                    {saldosCliente===null?'':(saldosCliente.PorVencerValor===null?'':formatearNumeroDecimal(saldosCliente.PorVencerValor))}
                  </LabelValueCliente>
                </ContainerCol>
                <ContainerCol className='col-sm-1'>
                  <BotonLinkDetDocumentos onClick={()=>{this.cargarDetalleDocumentos('PORVENCER')}}>Ver Detalle</BotonLinkDetDocumentos>
                </ContainerCol>
                <ContainerCol className='col-sm-3'>
                  <LabelPropCliente>Valor Notas Créd.:</LabelPropCliente>
                  <LabelValueCliente>
                    {saldosCliente===null?'':(saldosCliente.Credito===null?'':formatearNumeroDecimal(saldosCliente.Credito))}
                  </LabelValueCliente>
                </ContainerCol>
                <ContainerCol className='col-sm-1'>
                  <BotonLinkDetDocumentos onClick={()=>{this.cargarDetalleDocumentos('CREDITO')}}>Ver Detalle</BotonLinkDetDocumentos>
                </ContainerCol>
                <ContainerCol className='col-sm-3'>
                  <LabelPropCliente>Valor Cheques Postf.:</LabelPropCliente>
                  <LabelValueCliente>
                    {saldosCliente===null?'':(saldosCliente.ValorChequePosFechado===null?'':formatearNumeroDecimal(saldosCliente.ValorChequePosFechado))}
                  </LabelValueCliente>
                </ContainerCol>
                <ContainerCol className='col-sm-1'>
                  <BotonLinkDetDocumentos onClick={()=>{this.cargarDetalleDocumentos('CHEPOST')}}>Ver Detalle</BotonLinkDetDocumentos>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-12'>
                  <LabelPropCliente>Historial de Observaciones:</LabelPropCliente>
                  <TextArea readOnly={true} name='historialObservaciones' value={clienteSeleccionado===null?'':clienteSeleccionado.oberservaciones} 
                    maxLength='300' tamFuente='10'/>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-12'>
                  <LabelPropCliente>Últimas Gestiones:</LabelPropCliente>
                  <AgGridRender altura='170px' data={gestionesCliente} columnas={this.state.columnsDefGridUltGestiones}
                    gridOptions={this.gridUltGestionesOptions} onGridReady={this.onGridUltGestionesReady}/>
                </ContainerCol>
              </Row>
            </CuerpoForm>          
          </SubContenedorForm>
          
          <SubContenedorForm margen_arriba={30}>
            <HeaderForm>
              <SubTituloForm>Registro de Nueva Gestión</SubTituloForm>
            </HeaderForm>
            <CuerpoForm>              
                <Row margen_arriba={10}>
                  <ContainerCol className='col-sm-4'>
                    <LabelForm>Motivo Gestión:</LabelForm>
                    <ReactSelect options={ this.state.tiposGestion } value={ this.state.tipoGestion_sel }
                      func_onChange={(value)=>{if(Array.isArray(value)){value=null} this.setState({tipoGestion_sel: value===null?null:value.value})}}/>
                  </ContainerCol>
                  <ContainerCol className='col-sm-2'>
                    <LabelForm>Fecha:</LabelForm>
                    <PickerFecha fechaSeleccionada={this.state.fechaGestion} 
                      func_onChange={(fecha)=>{this.setState({fechaGestion: fecha});}}
                      disabled={!(this.props.permiteCambioFProceso==='S')}/>
                  </ContainerCol>
                </Row>
                <Row>
                  <ContainerCol className='col-sm-12'>                    
                    <LabelForm>Observación:</LabelForm>
                    <TextArea name='observacion' value={this.state.observacion} maxLength='300'
                      onChange={this.handleInputChange}/>                    
                  </ContainerCol>
                </Row>
                <Row>
                  <ContainerCol className='col-sm-2'>
                    <LabelForm>Fecha Próx. Gestión:</LabelForm>
                    <PickerFecha fechaSeleccionada={this.state.fechaProxGestion} func_onChange={(fecha)=>{this.setState({fechaProxGestion: fecha});}}/> 
                  </ContainerCol>
                  <ContainerCol className='col-sm-4'>
                    <LabelForm>Motivo Próx. Gestión:</LabelForm>
                    <ReactSelect options={ this.state.tiposGestion } value={ this.state.tipoProxGestion_sel }
                      func_onChange={(value)=>{if(Array.isArray(value)){value=null} this.setState({tipoProxGestion_sel: value===null?null:value.value})}}/> 
                  </ContainerCol>
                  <ContainerCol className='col-sm-offset-2 col-sm-4' margen_arriba={20}>
                    <div className='btn-group pull-right'>
                      <button type='button' className='btn btn-primary btn-sm' onClick={this.guardarGestionCliente}><i className='fa fa-save fa-lg'/> Guardar</button>
                      <button type='button' className='btn btn-sm' onClick={this.limpiarNuevaGestion}><i className='fa fa-trash-o fa-lg'></i> Limpiar</button>
                    </div>
                  </ContainerCol>
                </Row>
            </CuerpoForm>
          </SubContenedorForm>

          <ModalResponsive open={this.state.isVisibleModalDetDocs} onClose={()=>{this.setState({isVisibleModalDetDocs: false})}}>
            <ContainerModalDetDocs>
              <Row>
                <ContainerCol className='col-sm-12'>
                  <TituloModalDetDocumentos>{this.state.tituloModalDetDocumentos}</TituloModalDetDocumentos>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-12'>
                  <AgGridRender altura='350px' data={this.state.detalleDocumentos} columnas={this.state.columnsDefGridDetDocs}                
                    gridOptions={this.gridDetDocsOptions} onGridReady={this.onGridDetDocsReady}/>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-2'>
                  <LabelTotales>Total: </LabelTotales>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelValorTotales>{formatearNumeroDecimal(this.state.saldoDocumentos)}</LabelValorTotales>
                </ContainerCol>                
              </Row>
            </ContainerModalDetDocs>
          </ModalResponsive>
      </ContenedorFormSinColorFondo>
    )
  }
}

const mapStateToProps = state =>{
  return {  permiso: state.sesion.valoresSesionForm.Permiso,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
            clienteSel: state.clientes.clienteSel,
            gestionesClientePlanif: state.clientes.gestionesPlanif
  };
};

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,
                              cambiar_VisualizacionLoading, cargar_Cliente, inicializarCliente,
                              cargar_GestionesPorCliente, cargar_GestionesPlanificadas
                            }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormCli13);